/**
 * Včelařský rok (sezóna). Uživatel si v Nastavení zvolí měsíc začátku:
 * 1 = kalendářní rok (leden–prosinec), 8 = od srpna do července apod.
 * Sezóna se označuje rokem, ve kterém začíná.
 */
import type { ISODate } from './model';

export const SEASON_SETTING = 'seasonStartMonth';

export interface Season {
  /** Rok, ve kterém sezóna začíná. */
  year: number;
  from: ISODate;
  /** Poslední den sezóny (včetně). */
  to: ISODate;
  label: string;
}

const pad = (n: number) => String(n).padStart(2, '0');

function lastDayBefore(year: number, month: number): ISODate {
  // den před 1. dnem měsíce `month` roku `year`
  const d = new Date(Date.UTC(year, month - 1, 1));
  d.setUTCDate(0);
  return d.toISOString().slice(0, 10);
}

/** Měsíc začátku sezóny 1–12; nesmyslná hodnota (např. z ručně upravené zálohy) = leden. */
export function normStartMonth(startMonth: unknown): number {
  const n = Math.round(Number(startMonth));
  return Number.isFinite(n) && n >= 1 && n <= 12 ? n : 1;
}

export function season(year: number, startMonth: number): Season {
  const m = normStartMonth(startMonth);
  if (m === 1) return { year, from: `${year}-01-01`, to: `${year}-12-31`, label: String(year) };
  return {
    year,
    from: `${year}-${pad(m)}-01`,
    to: lastDayBefore(year + 1, m),
    label: `${year}/${String(year + 1).slice(2)}`,
  };
}

/** Sezóna, do které patří datum. */
export function seasonOf(date: ISODate, startMonth: number): Season {
  const y = Number(date.slice(0, 4));
  const mo = Number(date.slice(5, 7));
  const m = normStartMonth(startMonth);
  return season(mo >= m ? y : y - 1, m);
}

export function inSeason(date: ISODate, s: Pick<Season, 'from' | 'to'>): boolean {
  return date >= s.from && date <= s.to;
}

export const MONTHS = ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'];

/** Popis nastavení, např. „kalendářní rok“ nebo „od srpna do července“. */
export function seasonSettingLabel(month: number): string {
  const startMonth = normStartMonth(month);
  if (startMonth === 1) return 'kalendářní rok (leden–prosinec)';
  const endMonth = startMonth === 1 ? 12 : startMonth - 1;
  return `včelařský rok (${MONTHS[startMonth - 1]}–${MONTHS[endMonth - 1]})`;
}
